module.exports = __webpack_public_path__ + "img/clipboard-data.4ac93f6e.svg";